import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

export function LottieLoader() {
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!divRef.current) return;

        lottie.loadAnimation({
            name: 'full-screen-loader',
            container: divRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/lottie/lottie.json',
        });
        lottie.play();
        return () => {
            lottie.stop('full-screen-loader');
            lottie.destroy('full-screen-loader');
        };
    }, [divRef, lottie]);

    return (
        <div className="relative h-[80vh] w-full flex items-center justify-center">
            <div
                ref={divRef}
                className="relative flex items-center justify-center h-1/4 w-1/4 z-40 lottie"></div>
        </div>
    );
}
